export default {
  infos: {
    complete: {
      en: "The automaton is already complete",
      pt: "O autômato já está completo",
    },
    AFD: {
      en: "The automatons is already in FDA",
      pt: "O automato ja está em AFD",
    },
    needIsComplete: {
      en: "The automaton must be complete",
      pt: "O autômato precisa estar completo",
    },
    create: {
      en: "Automaton created",
      pt: "Autômato criado",
    },
    updated: {
      en: "Automaton updated",
      pt: "Autômato atualizado",
    },
    autoCreate: {
      en: "Automaton was saved automatically",
      pt: "Autômato salvo automaticamente",
    },
    autoUpdated: {
      en: "Automaton was updated automatically",
      pt: "Autômato atualizado automaticamente",
    },
  },
};
